import { render, staticRenderFns } from "./CourseTypesTable.vue?vue&type=template&id=f25697e2&"
import script from "./CourseTypesTable.vue?vue&type=script&lang=js&"
export * from "./CourseTypesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports